import { Component, Input } from '@angular/core';
import { AmtlichebewertungNeskoService, NeskoAbGrundstueckBeziehungListEntryMeta } from 'app/core/amtlichebewertung-api';
import { ListLoaderObservable } from 'app/shared/components/list-loader/list-loader-observable';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { BetragPipe } from '../../shared/pipes/simple/betrag.pipe';
import { DecimalHochkommaPipe } from '../../shared/pipes/simple/decimalHochkomma.pipe';
import { GrundstuecknummerPipe } from '../../shared/pipes/simple/grundstuecknummer.pipe';

@Component({
  selector: 'cap-neskoab-grundstuecke-zpvpersonen',
  templateUrl: './neskoab-grundstuecke-zpvpersonen.component.html',
  styleUrls: ['./neskoab-grundstuecke-zpvpersonen.component.scss'],
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, TranslatePipe, BetragPipe, DecimalHochkommaPipe, GrundstuecknummerPipe]
})
export class NeskoabGrundstueckeZpvpersonenComponent {
  listLoader: ListLoader<NeskoAbGrundstueckBeziehungListEntryMeta>;

  constructor(private neskoAbService: AmtlichebewertungNeskoService) {}

  @Input()
  set zpvNummer(value: string) {
    if (!value) {
      return;
    }
    this.listLoader = new ListLoaderObservable<NeskoAbGrundstueckBeziehungListEntryMeta>(
      undefined,
      1,
      this.neskoAbService.loadSichtByZpvNummer(value, 'de')
    );
  }
}
